module.exports = __webpack_public_path__ + "img/video-poster.cb00673d.jpg";